import { PRICE_RANGES } from "../../constants/metrics.constants"
import { IConditions } from "../../types/limitedCPC"
import { ICalcTargetCPC } from "../../types/metrics.types"

interface IApplyBidChangeLimits {
  bidInAmazon: number
  targetCPC: number
  currentAcos: number
  conditions: IConditions[]
  minTargetCPC: number
  maxTargetCPC: number
}

export function minMaxValidation(value: number, min: number, max: number): number {
  if (value < min) {
    return min
  }
  if (value > max) {
    return max
  }
  return value
}

export function applyBidChangeLimits(params: IApplyBidChangeLimits): number {
  const { bidInAmazon, targetCPC, currentAcos, conditions, minTargetCPC, maxTargetCPC } = params
  const condition = conditions.find(
    (condition) => condition.from <= currentAcos && condition.to >= currentAcos
  )

  const isIncrease = bidInAmazon < targetCPC
  const limitedCPC = isIncrease
    ? Math.min(bidInAmazon * (1 + (condition?.increaseBid || 0) / 100), targetCPC)
    : Math.max(bidInAmazon * (1 - (condition?.decreaseBid || 0) / 100), targetCPC)
  return minMaxValidation(limitedCPC, minTargetCPC, maxTargetCPC) || 0
}

export function calcTargetCPC(params: ICalcTargetCPC): number {
  const {
    targetAcos,
    orders,
    impressions,
    aovValue,
    clicks,
    bidInAmazon,
    currentAcos,
    sales,
    defaultBid,
  } = params

  if (!bidInAmazon) {
    return defaultBid
  }

  const CVR =
    PRICE_RANGES.find((range) => range.from <= aovValue && range.to >= aovValue)?.cvr ||
    PRICE_RANGES[0].cvr
  if (orders === 0 && impressions > 100) {
    const targetCPC = Math.min(
      aovValue * (targetAcos / 100) * (CVR / 100),
      aovValue * (targetAcos / 100) * (1 / (clicks + 1))
    )
    return Number(targetCPC?.toFixed(2))
  }

  if (orders === 0 && impressions <= 100) {
    const targetCPC = bidInAmazon * 1.05
    return Number(targetCPC?.toFixed(2))
  }

  if (orders >= 1 && orders <= 3 && currentAcos < 100) {
    return Number(bidInAmazon.toFixed(2))
  }

  if ((orders === 4 || orders === 5) && currentAcos < 50) {
    return Number(bidInAmazon.toFixed(2))
  }

  if (clicks === 0) {
    return Number(bidInAmazon.toFixed(2))
  }
  const targetCPC = (sales / clicks) * (targetAcos / 100)
  return Number(targetCPC.toFixed(2))
}
